<template lang="pug">
  div.text-left.pa-2
    .step1(v-if="currentStep == 1")
      .s1.basic100--text Swipe between statuses
      .p2.basic100--text.mt-2 Easily shift between Processing and Ready columns to keep track of orders you’re still preparing and orders that are ready to be shipped.
      
    div.d-flex.mt-4
      .p2.basic100--text.my-auto {{currentStep}}/{{ tour.steps.length }}
      v-spacer
      v-btn.text-uppercase.my-auto.mr-2(v-if="currentStep != 1" small text @click="tour.previousStep")
        span.basic100--text.button-Aa-small Prev
      v-btn.text-uppercase.my-auto(v-if="currentStep == tour.steps.length" small :color="$vuetify.theme.themes[$theme].basic100" @click="clickFinish")
        span.basic800--text.button-AA-small Finish
      v-btn.text-uppercase.my-auto(v-else small :color="$vuetify.theme.themes[$theme].basic100" @click="tour.nextStep")
        span.basic800--text.button-AA-small Next
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TourOrderKanbanView',
  props: {
    tour: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      orderTempData: 'tours/getOrderTempData'
    }),
    currentStep () {
      return this.tour.currentStep + 1
    }
  },
  methods: {
    clickFinish () {
      this.$tours['YezzaTour'].stop()
      let data = {
        extra_data: {
          kanbanView: true
        }
      }
      if (this.orderTempData.extra_data) {
        data.extra_data = { ...this.orderTempData.extra_data, kanbanView: true }
        if (this.orderTempData.extra_data.listView && this.orderTempData.extra_data.calendarView && this.orderTempData.extra_data.orderDetails) {
          data.value = 'completed'
        }
      }
      this.$axios.patch(`/companies/${this.orderTempData.company}/settings/${this.orderTempData.id}`, data)
        .then(resp => {
          this.$store.commit('tours/setOrderTempData', { company: this.orderTempData.company, ...resp.data })
        })
    }
  }
}
</script>

<style scoped>
</style>